var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModal", {
        attrs: { titulo: "Ver Detalle Lista de Distribución" },
        on: { cerrar: _vm.handleCerrar }
      }),
      _c(
        "v-card",
        { attrs: { height: "55px", flat: "" } },
        [
          _c(
            "v-bottom-nav",
            {
              attrs: {
                value: true,
                active: _vm.pasos.informacionGeneral.step,
                absolute: "",
                color: "transparent"
              },
              on: {
                "update:active": function($event) {
                  return _vm.$set(_vm.pasos.informacionGeneral, "step", $event)
                }
              }
            },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.informacionGeneral.visible,
                      expression: "pasos.informacionGeneral.visible"
                    }
                  ],
                  attrs: {
                    color: "primary",
                    flat: "",
                    value: _vm.pasos.informacionGeneral.step
                  },
                  on: { click: _vm.handleInfoGeneral }
                },
                [
                  _c("span", [_vm._v("Información General")]),
                  _c("v-icon", [_vm._v("info")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showInfo,
              expression: "showInfo"
            }
          ],
          staticClass: "cardnew",
          attrs: { align: "center" }
        },
        [
          _c("br"),
          _c("ListaDistribucionForm", {
            attrs: {
              listaSeleccionada: _vm.listaSeleccionada,
              isVerDetalle: true
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }